import Field from "@/components/Field";
import SettlementTypeSelect from "@/modules/projects/components/SettlementTypeSelect";
import { RoleBasedProjectSettlementTypeService } from "@/modules/projects/service/settlementType";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface SettlementTypeFieldProps {
  required?: boolean;
  disabled?: boolean;
}

const SettlementTypeFieldComponent = ({
  required = false,
  disabled = false,
}: SettlementTypeFieldProps) => {
  const { t } = useTranslation();
  return (
    <Field
      name="settlement_type"
      label={t("settlementType.label")}
      required={required}
      className="space-y-2"
      render={({ field }) => (
        <SettlementTypeSelect
          settlementTypeService={RoleBasedProjectSettlementTypeService}
          loading="eager"
          disabled={disabled}
          inDialog
          className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          {...field}
          defaultItem={{
            id: field.value,
            name: field.value ? t(`settlementType.${field.value}`) : undefined,
          }}
        />
      )}
    />
  );
};

export const SettlementTypeField = memo(SettlementTypeFieldComponent);
